import { MessageSquareHeart, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

/** Ventana mínima de «Pregunta a un experto»: fondo claro, un solo CTA a Avanzado. */
export default function AdvancedExpertDialog({ open, onOpenChange, lang }: { open: boolean; onOpenChange: (o: boolean) => void; lang: "es" | "en" }) {
  const es = lang === "es";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm gap-0 rounded-3xl border border-border bg-background p-6 shadow-xl">
        <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
          <MessageSquareHeart className="h-5 w-5" strokeWidth={1.5} />
        </span>
        <DialogTitle className="mt-4 font-display text-xl font-bold leading-tight text-foreground">
          {es ? "Pregunta a un experto" : "Ask an expert"}
        </DialogTitle>
        <DialogDescription className="mt-2 text-sm leading-relaxed text-muted-foreground">
          {es
            ? "El Plan Avanzado incluye todo el Club Pro y el empujón para avanzar de verdad. Cuando el Agente no basta, un experto del sector lo revisa contigo."
            : "The Advanced plan includes everything in Club Pro, plus the push to really move forward. When the Agent isn't enough, a sector expert reviews it with you."}
        </DialogDescription>
        <a href={es ? "/tarifas" : "/en/pricing"} className="mt-5 flex min-h-11 items-center justify-center gap-2 rounded-full bg-primary px-4 text-sm font-bold text-primary-foreground hover:brightness-95">
          {es ? "Ver Plan Avanzado" : "See Advanced plan"}<ArrowRight className="h-4 w-4" />
        </a>
      </DialogContent>
    </Dialog>
  );
}
